import store from '../store/index'

// const httpid = 'http://localhost:5001/'
//  const baserurl = 'http://localhost:5001/api/'
const httpid = 'http://101.43.39.117:9311/'
const baserurl = 'http://101.43.39.117:9311/api/'
// const httpid = 'http://101.43.39.117:9201/'
// const baserurl = 'http://101.43.39.117:9201/api/'
const groupid = 0
const chaturl = 'http://101.43.39.117:7019/'
const topicurl = 'http://101.43.39.117:9315/'
const knowledgeurl = 'http://101.43.39.117:9320/' //知识点API
const knowledgeImg = 'http://101.43.39.117:9322'
// const knowledgeurl = 'http://localhost:5002/' //知识点API
//const studenturl = 'hq.chongfeng'
 const studenturl = '101.43.39.117:9312/'
// const studenturl = 'localhost:8083/'
const currtround = localStorage.getItem('CurrentRound')

const signalR = require('@microsoft/signalr')
//const imgip = 'http://localhost:5001/'
const imgip = 'http://101.43.39.117:5023/'
const SModelStateNewModel = 3
const RoomStateWork = 1
const RoomStatedelete = 2
const msgList = []
const caseID = localStorage.getItem('caseId')
const expid = localStorage.getItem('expID')
const UserName = "会展PC"
const UUID = "chenniao_Exhibition"

const chartColor =  ["#FF9F7F","#67E0E3","#FFDB5C","#9FE6B8","#32C5E9","#37a2da","#fb7293","#e062ae","#e690d1","#e7bcf3","#9d96f5","#8378ea","#96bfff"]
const globalColor = '#0166FF'
const SModel = {
  Create: 2,
  Update: 1,
  Delete: 0,
  NewModel: 3,
  Remove: -1,
}
//表单枚举
const EnumUserStatus = {
  normal: 1,
  delete: 0,
}
const chatTemplateID={
  会展策划:22,
  媒体邀约:23,
  主题招商演讲:24,
  展位招商:25,
  活动文案:26,
  广告招商:27
}
const AiEnum={
  会展策划:0,
  媒体邀约:1,
  主题招商演讲:2,
  展位招商:3,
  活动文案:4,
  广告招商:5

}
//企业购买枚举
const EnumPurchase = {
  purchase: 0,
  cancellation: 1,
}
//企业类型枚举
const EnterpriseType = {
  Faucet: 1, //龙头企业
  large: 2, //大型企业
  medium: 3, //中型企业
  small: 4, //小型企业
}
const TargetType = [
  {
    name: '参观观众',
    id: 1,
  },
  {
    name: '参展商',
    id: 2,
  },
]
//是否再次参加
const IsParticipateEnum = {
  /// 是，愿意再次参加
  是: 1,
  /// 有待考虑
  有待考虑: 2,
  /// 否，不愿意再次参加
  否: 3,
}
const IncometType = {
  expenditure: 0,
  income: 1,
}
const StayState = {
  Pending: 0, //未处理
  destined: 1, //预定
}

const BudgetAuditState = {
  Unaudited: 0, //未审核
  Approved: 1, //审核通过
  Refuse: 2, //拒绝
}

const AttractInvestment = {
  ThemeExpert: 0, //主题招商行业专家
  Booth: 1, //展位
  Advertisement: 2, //广告
  ThemeEnterprise: 3, //主题招商企业
}
const AttractInvestmentType = {
  Expert: 0, //专家
  Enterprise: 1, //企业
}
//回执
const ReceiptState = {
  READ: 0, //已读
  UNREAD: 1, //未读
}
//开票类型
const VoteType = {
  专票: 1,
  普票: 2,
}
const VoteTypeList = [
  {
    value: 1,
    label: '专票',
  },
  {
    value: 2,
    label: '普票',
  },
]
//流程
const FlowList = {
  策划: 1,
  招商: 2,
  执行: 3,
  反馈: 4,
  实验总结: 5,
}
//支出类型
const PayType = {
  信息发布成本: 1,
  特邀专家费: 2,
  企业数据费: 3,
  场地费用: 4,
  住宿: 5,
  差旅: 6,
  餐饮: 7,
  秩序维护: 8,
  问卷调查: 9,
  媒体邀约成本: 10,
  主题演讲企业成本: 11,
  展位招商企业成本: 12,
  广告招商企业成本: 13,
  人员成本: 14,
  茶点: 15,
  正餐: 16,
  设计费用: 17,
  会场费用: 18,
  活动费用: 19,
}
const OperateType = {
  目标行业 :1,
  目标客户 : 2,
  会展场地 : 3,
  会展需求 : 4,
  会展策划 : 5,
  预算审核 : 6,
  活动策划 : 7,
  价格制定 : 8,
  信息发布 : 9,
  媒体邀约 : 10,
  主题招商专家 : 11,
  主题招商企业 : 12,
  展位招商 : 13,
  广告招商 : 14,
  营销数据管理 : 15,
  查看市场分析 : 16,
  住宿安排 : 17,
  餐饮安排 : 18,
  车辆安排 : 19,
  现场跟踪及营销 : 20,
  展后新闻报道 : 21,
  反馈调查 : 22,
  发票管理 : 23,
  过程数据分析查看 : 24,
  查看会展营销总结 : 25,
  查看数据分析总结 : 26,
  查看会展服务总结 : 27,
  查看财务数据总结 : 28,
  实验报告上传 : 29,
  秩序维护 : 30,
  招商回执 : 31,
  查看产地数据 : 32,
  查看场地询价 : 33,
  查看场地询价详情 : 35,
  沙盘精灵 : 36,
  查看反馈数据管理 : 37,
  查看支出管理 : 38,
  查看收入管理 : 39,
  查看报表管理 : 40,
  查看营收状况分析 : 41,
  查看虚拟场景 : 42,
  查看引导操作 : 43

}
//支出类型
const PayTypes = [
  {
    name: '信息发布成本',
    id: 1,
  },
  {
    name: '特邀专家费',
    id: 2,
  },
  {
    name: '企业数据费',
    id: 3,
  },
  {
    name: '场地费用',
    id: 4,
  },
  {
    name: '住宿',
    id: 5,
  },
  {
    name: '差旅',
    id: 6,
  },
  {
    name: '餐饮',
    id: 7,
  },
  {
    name: '秩序维护',
    id: 8,
  },
  {
    name: '问卷调查',
    id: 9,
  },
  {
    name: '媒体邀约成本',
    id: 10,
  },
  {
    name: '主题演讲企业成本',
    id: 11,
  },
  {
    name: '展位招商企业成本',
    id: 12,
  },
  {
    name: '广告招商企业成本',
    id: 13,
  },
  {
    name: '人员成本',
    id: 14,
  },
  {
    name: '茶点',
    id: 15,
  },
  {
    name: '正餐',
    id: 16,
  },
  {
    name: '设计费用',
    id: 17,
  },
  {
    name: '会场费用',
    id: 18,
  },
  {
    name: '活动费用',
    id: 19,
  },
]
//收入类型
const IncometTypes = [
  {
    name: '大展位费',
    id: 1,
  },
  {
    name: '中展位费',
    id: 2,
  },
  {
    name: '小展位费',
    id: 3,
  },
  {
    name: '门票费',
    id: 4,
  },
  {
    name: '广告收入',
    id: 5,
  },
  {
    name: '主题演讲',
    id: 6,
  },
]
//开票类型
const FinanceType = {
  收入: 1,
  支出: 2,
}
//开票情况
const Invoicing = {
  已开票: 1,
  未开票: 2,
}
//回执类型
const ReceiptType = [
  {
    name: '媒体邀约',
    id: 1,
  },
  {
    name: '专家回执',
    id: 2,
  },
  {
    name: '企业回执',
    id: 3,
  },
  {
    name: '展位展商',
    id: 4,
  },
  {
    name: '广告招商',
    id: 5,
  },
]
//餐饮
const RestaurantTypeList = [
  {
    name: '正餐',
    participants: '专家',
    id: 1,
    type: '桌',
  },
  {
    name: '茶点',
    participants: '全部人员',
    id: 2,
    type: '位',
  },
]
const KnowledgeTypeList = [
  { value: 1, name: '目标行业' },
  { value: 2, name: '目标客户' },
  { value: 3, name: '会展场地' },
  { value: 4, name: '会展需求' },
  { value: 5, name: '会展策划' },
  { value: 6, name: '预算制定' },
  { value: 7, name: '预算审核' },
  { value: 8, name: '活动策划' },
  { value: 9, name: '价格制定' },
  { value: 10, name: '营销数据管理' },
  { value: 11, name: '信息发布' },
  { value: 12, name: '媒体邀约' },
  { value: 13, name: '行业专家邀请' },
  { value: 14, name: '企业招商' },
  { value: 15, name: '展位招商' },
  { value: 16, name: '广告招商' },
  { value: 17, name: '住宿管理' },
  { value: 18, name: '餐饮安排' },
  { value: 19, name: '车辆调度' },
  { value: 20, name: '秩序维护' },
  { value: 21, name: '现场跟踪及营销' },
  { value: 22, name: '反馈调查' },
  { value: 23, name: '发票开具' },
  { value: 24, name: '展后新闻报道' },
  { value: 25, name: '场地询价' }
]
const ProjectType = {
  会展项目 : 1,
  酒店PC项目 : 2,
}
const CommentStateEnum = {
  删除: 0,
  正常: 1,
  待审核: 2,
  拒绝: 3
}
//现场跟踪状态
const SceneState = {
  Tracked: 1, //已跟踪
  NotTracked: 0, //未跟踪
}
function getsmodel(slist) {
  let smodel = []
  slist.forEach((item) => {
    item.groupId = parseInt(localStorage.getItem('groupID'))
    smodel.push({
      id: item.iD,
      groupId: item.groupId,
      round: item.round,
      type: item.type,
      uuid: item.uuid,
      content: JSON.stringify(item),
    })
  })
  return smodel
}

function GetBudget(money) {
  let Money = store.state.user.Money
  Money -= parseFloat(money)
  if (Money > 0) {
    store.commit('setMoney', Money)
    this.sendmsgmd('', '', 2)
    //localStorage.setItem('Money', Money)
    return true
  } else return false
}

function msgload() {
  if(!this.connection){
    this.connection = new signalR.HubConnectionBuilder()
    .configureLogging(signalR.LogLevel.Information)
    .withUrl(`${this.httpid}chathub?username=${this.username}`, {
      accessTokenFactory: () => localStorage.getItem('accessToken'),
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: () => {
        //每5秒重连一次
        return 5000
      },
    }) //自动重连
    .build()
  }
  this.connection.on('ReceiveMessage', (data) => {
    //拿到消息进行解析
    console.log(data)
    switch (data.msgtype) {
      case 5:
        store.commit('chagemsg', data)
        break
      case 2:
        store.commit('setMoney', data.money)
        break
      case 1:
        store.commit('setOperationmsg', data.username + data.msg)
        break
      case 3:
        store.commit('changedepcomit', data.depcount)
        store.commit('setOperationmsg', data.msg)
        break
      case 4:
        store.commit('chageSPmsg', data)
        break
    }
    // console.log();
    msgList.push(data)
  })

  this.connection.start()
}

function beforeDestroy() {
  if(this.connection != undefined){
    //在退出界面时关闭连接
    this.connection.off('Show')
    let params = {
      username: '',
      msg: '',
      msgtype: 0,
      time: new Date().format('yyyy-MM-dd hh:mm'),
      msgState: 2,
      money: store.state.user.Money,
      depcount: store.state.user.depcomit,
      group: localStorage.getItem('accessToken'),
    }
    // console.log(params);
    this.connection.invoke('Releve', params)
    this.connection = undefined
  }

}
//msgtype 1消息，2金额更新，3.等待
function sendmsgmd(username, message, msgtype) {
  let params = {
    username: username,
    msg: message,
    msgtype: msgtype,
    time: new Date().format('yyyy-MM-dd hh:mm'),
    msgState: 2,
    money: store.state.user.Money,
    depcount: store.state.user.depcomit,
    group: localStorage.getItem('accessToken'),
    guid: '',
  }
  // console.log(params);
  this.connection.invoke('SenlGroupMsg', params)
}
function sendmschatgmd(username, message, msgtype, guid) {
  let params = {
    username: username,
    msg: message,
    msgtype: msgtype,
    time: new Date().format('yyyy-MM-dd hh:mm'),
    msgState: 2,
    money: store.state.user.Money,
    depcount: store.state.user.depcomit,
    group: localStorage.getItem('accessToken'),
    guid: guid,
  }
  // console.log(params);
  this.connection.invoke('SenlGroupMsg', params)
}
function prasendmsgmd(username, message, msgtype) {
  let params = {
    username: username,
    msg: message,
    msgtype: msgtype,
    time: new Date().format('yyyy-MM-dd hh:mm'),
    msgState: 2,
    money: store.state.user.Money,
    depcount: store.state.user.depcomit,
    group: localStorage.getItem('accessToken'),
  }
  return params
}
function sendMsg(username, message) {
  let params = {
    username: username,
    msg: message,
    group: localStorage.getItem('accessToken'),
  }
  // console.log(params);
  this.connection.invoke('SenlGroupMsg', params)
}

export default {
  StayState,
  beforeDestroy,
  baserurl,
  sendmsgmd,
  msgload,
  sendMsg,
  httpid,
  imgip,
  getsmodel,
  GetBudget,
  currtround,
  groupid,
  SModelStateNewModel,
  RoomStateWork,
  RoomStatedelete,
  expid,
  caseID,
  SModel,
  EnumPurchase,
  IncometType,
  EnterpriseType,
  TargetType,
  IsParticipateEnum,
  BudgetAuditState,
  AttractInvestment,
  ReceiptState,
  VoteType,
  AttractInvestmentType,
  FlowList,
  PayType,
  FinanceType,
  ReceiptType,
  RestaurantTypeList,
  PayTypes,
  IncometTypes,
  SceneState,
  VoteTypeList,
  Invoicing,
  prasendmsgmd,
  chaturl,
  sendmschatgmd,
  EnumUserStatus,
  topicurl,
  studenturl,
  chartColor,
  globalColor,
  AiEnum,
  chatTemplateID,
  UserName,
  UUID,
  OperateType,
  knowledgeurl,
  KnowledgeTypeList,
  ProjectType,
  knowledgeImg,
  CommentStateEnum
}
